module.exports = __webpack_public_path__ + "img/contact_final.220a1261.jpg";